import React, { Component } from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import EkspedisiDetailTab from "./ekspedisiDetailTab";
import {
  BARCODE_ENCRYPTED_KEY_MAP,
  BARCODE_KEY_MAP,
  CATEGORY_MAP,
  CONFIG_DETAIL,
  constructDataDetail,
  constructPayload,
  constructPayloadCetak,
  Kode_KEY_MAP,
  SERVICE,
  STATUS_KEY_MAP,
  STOCK_LIST_MAP,
} from "../config";
import EkspedisiDetailContentInput from "./ekspedisiDetailContentInput";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleTextArea from "../../../../modules/simpleTextArea";
import SimpleUploadImage from "../../../../modules/upload/SimpleUploadImage";
import ErrorAction from "../../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import * as R from "ramda";
import { contructQueryParam, fetchDataAsync } from "../../../../Services/Utils";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import EkspedisiPreviewPDF from "./ekspedisiPreviewPDF";
import SimpleInput from "../../../../modules/SimpleInput";
import { printPDF } from "./printUtils";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import Api from "../../../../Services/Api";
import { HttpStatus } from "../../../common/Constants";
import { mapToObjectDDL } from "../../../common/mapper";

class EkspedisiDetailContent extends Component {
  TAB_LIST = ["KSU", "Hadiah", "OtherItem", "Part"];

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      cetakVisible: false,
      previewCetakVisible: false,
      bstkHadiahVisible: false,
      showErrors: false,
      dataHeader: {},
      dataTable: {
        KSU: [],
        Hadiah: [],
        OtherItem: [],
        Part: [],
      },
      dataTableNoQR: {
        KSU: [],
        Hadiah: [],
        OtherItem: [],
        Part: [],
      },
      dataSupir: null,
      dataFoto: null,
      dataCetakan: null,
      dataCetakanBSTKHadiah: {
        row1: null,
        row2: null,
        row3: null,
        row4: null,
      },
      supirOptions: [],
      PDF: null,
      editingRow: {
        tab: null,
        rowIndex: null,
        data: {},
      },
      listKSU: [],
      listHadiah: [],
      listOtherItem: [],
      listPart: [],
      isAddingRow: false,
      barcodeUsed: {
        ksuBarcode: [],
        giftBarcode: [],
        otherBarcode: [],
        partBarcode: [],
        visible: false,
      },
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    this.fetchData();
    this.fetchDataDriver();
    this.fetchDataKSU();
    this.fetchDataPart();
    // this.fetchDataHadiah();
    // this.fetchDataOtherItem();
    const FETCH_TYPE_MAP = [
      { type: "GIFT", stateKey: "listHadiah" },
      { type: "OTHER", stateKey: "listOtherItem" },
    ];

    FETCH_TYPE_MAP.forEach(({ type, stateKey }) => {
      this.fetchDataByType(type, stateKey);
    });
    this.handleTriggerLoading();
  };

  callApi = async (api, args) => {
    return await fetchDataAsync({
      asyncFn: api,
      menuName: "Ekspedisi",
      setError: this.props.setError,
      args: args,
    });
  };

  fetchDataKSU = async (body) => {
    let req =
      body && Object.keys(body).length > 0
        ? body
        : {
            paramFilters: {},
            page: null,
            limit: null,
          };
    let res = await this.callApi(
      Api.create("NAGAMAS_MASTER_DATA").getAllKSUPagingByParam,
      req,
    );

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevState) => ({
        ...prevState,
        listKSU: res.data.data,
      }));
    }
  };

  fetchDataByType = async (type, stateKey) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: { ...prevValue.pagination, count: 0 },
    }));

    const req = contructQueryParam({
      kodeCabang: this.props.selectedCabang?.value,
      type: type,
    });

    const res = await this.callApi(
      Api.create("NAGAMAS_TRANSACTION").getDataForEkspedisi,
      req,
    );

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevState) => ({
        ...prevState,
        [stateKey]: res.data.data,
      }));
    }
  };

  fetchDataPart = async () => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: { ...prevValue.pagination, count: 0 },
    }));

    const req = contructQueryParam({
      kodeCabang: this.props.selectedCabang?.value,
    });

    const res = await this.callApi(
      Api.create("NAGAMAS_TRANSACTION").getDataForEkspedisiPart,
      req,
    );

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevState) => ({
        ...prevState,
        listPart: res.data.data,
      }));
    }
  };

  handleActionQRCode = (index, value, tab) => {
    this.setState((prev) => ({
      dataTable: {
        ...prev.dataTable,
        [tab]: prev.dataTable[tab].map((row, i) =>
          i === index ? { ...row, [BARCODE_KEY_MAP[tab]]: value } : row,
        ),
      },
    }));
  };

  handleActionMenyusul = (index, value, tab) => {
    this.setState((prev) => ({
      dataTable: {
        ...prev.dataTable,
        [tab]: prev.dataTable[tab].map((row, i) =>
          i === index ? { ...row, menyusul: value } : row,
        ),
      },
    }));
  };

  handleActionNoQRCode = (index, name, value, tab) => {
    if (!STATUS_KEY_MAP[tab]) return;
    this.setState((prev) => ({
      dataTableNoQR: {
        ...prev.dataTableNoQR,
        [tab]: prev.dataTableNoQR[tab].map((row, i) =>
          i === index ? { ...row, [STATUS_KEY_MAP[tab]]: value?.value } : row,
        ),
      },
    }));
  };

  handleActionNoQRMenyusul = (index, value, tab) => {
    this.setState((prev) => ({
      dataTableNoQR: {
        ...prev.dataTableNoQR,
        [tab]: prev.dataTableNoQR[tab].map((row, i) =>
          i === index ? { ...row, menyusul: value } : row,
        ),
      },
    }));
  };

  handleRefresh = async () => {
    this.handleTriggerLoading();
    const { pdiNo } = this.state.dataHeader;
    const req = contructQueryParam({ pdiNo });
    const res = await SERVICE[this.props.tab].refreshExpedition(
      this.props.setError,
      req,
    );

    if (res?.ok && R.equals(res?.data?.status, "S")) {
      const { data } = res.data;
      this.setState((prev) => ({
        dataTable: {
          ...prev.dataTable,
          KSU: this.updateBarcode(
            prev.dataTable.KSU,
            data.ksu,
            "ksuCode",
            "ksuBarcode",
            "ksuBarcodeEncrypted",
          ),
          Hadiah: this.updateBarcode(
            prev.dataTable.Hadiah,
            data.giftBarcode,
            "giftCode",
            "giftBarcode",
            "giftBarcodeEncrypted",
          ),
          OtherItem: this.updateBarcode(
            prev.dataTable.OtherItem,
            data.otherItemBarcode,
            "otherItemCode",
            "otherItemBarcode",
            "otherItemBarcodeEncrypted",
          ),
          Part: this.updateBarcode(
            prev.dataTable.Part,
            data.partBarcode,
            "partCode",
            "partBarcode",
            "partBarcodeEncrypted",
          ),
        },
        dataSupir: {
          ...prev.dataSupir,
          deliveryManId:
            prev.dataSupir?.deliveryManId ?? data.dataSupir?.deliveryManId,
          addressNote:
            prev.dataSupir?.addressNote ?? data.dataSupir?.addressNote,
        },
        dataFoto: data?.photoGesekanBase64,
      }));
    }
    this.handleTriggerLoading();
  };

  updateBarcode = (dataArray, dataList, codeKey, barcodeKey, encryptedKey) =>
    dataArray.map((data) => {
      const found = dataList.find((item) => item.id === data.id);
      return found
        ? {
            ...data,
            [barcodeKey]: found[barcodeKey],
            [encryptedKey]: found[encryptedKey],
          }
        : data;
    });

  handleProses = async () => {
    const { dataTable } = this.state;

    const isDataIncomplete = Object.values(dataTable).some((items) =>
      items.some((item) => {
        const barcode =
          item.ksuBarcode ??
          item.giftBarcode ??
          item.otherItemBarcode ??
          item.partBarcode;

        return !barcode && item.menyusul === false;
      })
    );

    let barcodes = this.extractBarcode(dataTable);

    if (isDataIncomplete) {
      this.handleAlertWarningVisibility(
        "Data belum lengkap. Harap lakukan Scan ATAU Centang Menyusul sebelum melanjutkan Proses"
      );
      return;
    }

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").checkStatusBarcodeBulk,
      setError: this.props.setError,
      menuName: "Belum PDI",
      args: { ...barcodes, pdiNo:this.state.dataHeader?.pdiNo, },
    });

    if (!res?.ok || res?.data?.status !== HttpStatus.SUCCESS || !res?.data?.data) {
      return;
    }

    const req = constructPayload(this.state, this.props);

    if (req.deliveryManId === null) {
      this.setState({ showErrors: true });
      this.handleAlertModalProsesVisibility();
    } else if (this.showBarcodeError(res.data.data)) {
      // do nothing
    } else {
      this.props.onSubmitProses(req);
    }
  };

  showBarcodeError = (data) => {
    const barcodeBooked = [
      data.ksuBarcode,
      data.giftBarcode,
      data.otherBarcode,
      data.partBarcode,
    ].some(barcodes => (barcodes?.length ?? 0) > 0);
    if (barcodeBooked) this.handleAlertBarcodeUsed(true, data);
    return barcodeBooked;
  };

  handleAlertBarcodeUsed = (visible, data) => {
    const barcode = {
      ksuBarcode: data?.ksuBarcode ?? [],
      giftBarcode: data?.giftBarcode ?? [],
      otherBarcode: data?.otherBarcode ?? [],
      partBarcode: data?.partBarcode ?? [],
    };
    this.setState(prevState => ({
      barcodeUsed: {
        ...prevState.barcodeUsed,
        visible: visible,
        ...barcode,
      },
    }));
  }

  extractBarcode = (body) => {
    return {
      ksuBarcode: this.getBarcode(body.KSU, "ksuBarcode"),
      giftBarcode: this.getBarcode(body.Hadiah, "giftBarcode"),
      otherBarcode: this.getBarcode(body.OtherItem, "otherItemBarcode"),
      partBarcode: this.getBarcode(body.Part, "partBarcode"),
    }
  }

  getBarcode = (list, key) => {
    return (list ?? [])
      .map(item => item[key])
      .filter(value =>
        typeof value === "string" &&
        !R.isEmpty(value.trim()));
  }

  handleAlertModalProsesVisibility = () =>
    this.setState((prev) => ({
      alertModalProsesVisible: !prev.alertModalProsesVisible,
    }));

  handleAlertWarningVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      warningVisible: !prevState.warningVisible,
    }));
  };

  handleChangeCetakBSTKHadiah = (name, value) =>
    this.setState((prev) => ({
      dataCetakanBSTKHadiah: { ...prev.dataCetakanBSTKHadiah, [name]: value },
    }));

  handleCetakVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      cetakVisible: !prevState.cetakVisible,
    }));
  };

  handleCetak = async () => {
    this.handleTriggerLoading();
    const { dataCetakan, dataHeader, dataCetakanBSTKHadiah } = this.state;
    const username = this.props.auth.user.username;
    if (dataCetakan === null) return;
    this.handleCetakVisibility();
    const req = constructPayloadCetak(
      dataCetakan,
      dataHeader,
      dataCetakanBSTKHadiah,
      username,
    );
    const res = await SERVICE["CETAK"][dataCetakan?.value](
      this.props.setError,
      req,
    );

    if (res.ok) {
      // this.setState((prevState) => ({
      //     ...prevState,
      //     PDF: URL.createObjectURL(res.data)
      // }))
      printPDF(res.data);
      // this.previewCetakanVisibility();
    }
    this.handleTriggerLoading();
  };

  previewCetakanVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      previewCetakVisible: !prevState.previewCetakVisible,
    }));
  };

  handleStateChange = (callback) => this.setState(callback);

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchData = async () => {
    const { nomorEkspedisi } = this.props.selectedData;
    const req = contructQueryParam({ expeditionNo: nomorEkspedisi });
    const res = await SERVICE[this.props.tab].getById(this.props.setError, req);
    if (res?.ok && R.equals(res?.data?.status, "S")) {
      const constructed = constructDataDetail({
        ...res.data.data,
        tglFakturJual: this.props.selectedData?.tanggalFakturJual,
      });

      if (constructed.dataTable) {
        Object.keys(constructed.dataTable).forEach((tab) => {
          constructed.dataTable[tab] = (constructed.dataTable[tab] || []).map(
            (row) => ({
              ...row,
              action: { saved: true },
            }),
          );
        });
      }

      if (constructed.dataTableNoQR) {
        Object.keys(constructed.dataTableNoQR).forEach((tab) => {
          constructed.dataTableNoQR[tab] = (
            constructed.dataTableNoQR[tab] || []
          ).map((row) => ({
            ...row,
            action: { saved: true },
          }));
        });
      }

      this.setState({
        ...constructed,
      });
    }
  };

  fetchDataDriver = async () => {
    const res = await Api.create("NAGAMAS_MASTER_DATA").getDriverForEkspedisi(
      this.props.selectedCabang?.value,
    );
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        supirOptions: res.data.data.map((item) =>
          mapToObjectDDL(item.driverName, item.driverId),
        ),
      });
    }
  };

  handleAddRowWithQR = (tab) => {
    const qtyFieldMap = {
      KSU: "ksuQty",
      Hadiah: "giftQty",
      OtherItem: "otherItemQty",
      Part: "partQty",
    };

    const qtyField = qtyFieldMap[tab];

    this.setState((prev) => {
      const newRow = {
        id: null,
        menyusul: false,
        pdiNo: this.state.dataHeader?.pdiNo,
        [Kode_KEY_MAP[tab]]: null,
        [CATEGORY_MAP[tab]]: null,
        [BARCODE_KEY_MAP[tab]]: null,
        [BARCODE_ENCRYPTED_KEY_MAP[tab]]: null,
        source: "",
        action: { saved: false },
        ...(qtyField ? { [qtyField]: null } : {}),
      };

      const newIndex = prev.dataTable?.[tab]?.length || 0;

      return {
        isAddingRow: true,
        dataTable: {
          ...prev.dataTable,
          [tab]: [...(prev.dataTable?.[tab] || []), newRow],
        },
        editingRow: { tab, rowIndex: newIndex, data: newRow },
      };
    });
  };

  handleAddRowWithoutQR = (tab) => {
    const qtyFieldMap = {
      KSU: "ksuQty",
      Hadiah: "giftQty",
      OtherItem: "otherItemQty",
      Part: "partQty",
    };

    const qtyField = qtyFieldMap[tab];

    this.setState((prev) => {
      const newRow = {
        id: Date.now(),
        menyusul: false,
        [Kode_KEY_MAP[tab]]: "",
        [CATEGORY_MAP[tab]]: "",
        [STATUS_KEY_MAP[tab]]: "OK",
        ...(qtyField ? { [qtyField]: null } : {}),
        source: "",
        action: { saved: false },
        inStock: null,
        qty: null
      };

      const newIndex = prev.dataTableNoQR?.[tab]?.length || 0;

      return {
        isAddingRow: true,
        dataTableNoQR: {
          ...prev.dataTableNoQR,
          [tab]: [...(prev.dataTableNoQR?.[tab] || []), newRow],
        },
        editingRow: { tab, rowIndex: newIndex, data: newRow },
      };
    });
  };

  handleEditRow = (rowIndex, tab) => {
    const row = this.state.dataTable?.[tab]?.[rowIndex];
    if (!row) return;

    const isFromSalesOrder = row?.source === "SALES_ORDER";
    const isProsesMode = this.props.actionType === "proses";

    if (isProsesMode && isFromSalesOrder) return;

    this.setState({
      editingRow: {
        tab,
        rowIndex,
        data: { ...row },
      },
      isAddingRow: false,
    });
  };

  handleSaveRow = (tab) => {
    const { editingRow, dataTable } = this.state;
    const { rowIndex, data } = editingRow || {};

    if (rowIndex === null || rowIndex === undefined) return;
    if (!dataTable?.[tab]?.[rowIndex]) return;

    const updatedRows = [...dataTable[tab]];
    updatedRows[rowIndex] = {
      ...updatedRows[rowIndex],
      action: { saved: true },
    };

    this.setState({
      dataTable: { ...dataTable, [tab]: updatedRows },
      editingRow: null,
      isAddingRow: false,
    });
  };

  handleEditRowNoQR = (rowIndex, tab) => {
    const row = this.state.dataTableNoQR?.[tab]?.[rowIndex];
    if (!row) return;

    const isFromSalesOrder = row?.source === "SALES_ORDER";
    const isProsesMode = this.props.actionType === "proses";

    if (isProsesMode && isFromSalesOrder) return;

    this.setState({
      editingRow: {
        tab,
        rowIndex,
        data: { ...row },
      },
      isAddingRow: false,
    });
  };

  // handleSaveRowNoQR = (tab) => {
  //   const { editingRow, dataTableNoQR } = this.state;
  //   const { rowIndex, data } = editingRow || {};

  //   if (rowIndex === null || rowIndex === undefined) return;
  //   if (!dataTableNoQR?.[tab]?.[rowIndex]) return;

  //   const updatedRows = [...dataTableNoQR[tab]];
  //   updatedRows[rowIndex] = {
  //     ...updatedRows[rowIndex],
  //     action: { saved: true },
  //   };

  //   this.setState({
  //     dataTableNoQR: {
  //       ...dataTableNoQR,
  //       [tab]: updatedRows,
  //     },
  //     editingRow: null,
  //     isAddingRow: false,
  //   });
  // };

  handleSaveRowNoQR = (tab) => {
    const { editingRow, dataTableNoQR } = this.state;
    const { rowIndex } = editingRow || {};

    if (rowIndex === null || rowIndex === undefined) return;
    if (!dataTableNoQR?.[tab]?.[rowIndex]) return;

    const rowData = dataTableNoQR[tab][rowIndex];
    console.log(rowData);
    
    if (rowData.inStock === false) {
      this.handleAlertWarningVisibility("Stock tidak tersedia!");
      return;
    }

    if (rowData.inStock === null) {
      this.handleAlertWarningVisibility("Item belum dipilih!");
      return;
    }

    if (Number(rowData.giftQty || rowData.otherItemQty || rowData.partQty) > Number(rowData.qty)) {
      this.handleAlertWarningVisibility("Stock tidak tersedia!");
      return;
    }

    const updatedRows = [...dataTableNoQR[tab]];
    updatedRows[rowIndex] = {
      ...rowData,
      action: { saved: true },
    };

    this.setState({
      dataTableNoQR: {
        ...dataTableNoQR,
        [tab]: updatedRows,
      },
      editingRow: null,
      isAddingRow: false,
    });
  };

  handleDeleteRow = (rowIndex, tab) => {
    const currentRows = [...(this.state.dataTable?.[tab] || [])];
    if (!currentRows[rowIndex]) return;

    currentRows.splice(rowIndex, 1);

    this.setState((prev) => ({
      dataTable: {
        ...prev.dataTable,
        [tab]: currentRows,
      },
      editingRow:
        prev.editingRow?.tab === tab && prev.editingRow?.rowIndex === rowIndex
          ? null
          : prev.editingRow,
    }));
  };

  handleDeleteRowNoQR = (tab, rowIndex) => {
    const currentRows = [...(this.state.dataTableNoQR?.[tab] || [])];
    if (!currentRows[rowIndex]) return;

    currentRows.splice(rowIndex, 1);

    this.setState((prev) => ({
      dataTableNoQR: {
        ...prev.dataTableNoQR,
        [tab]: currentRows,
      },
      editingRow:
        prev.editingRow?.tab === tab && prev.editingRow?.rowIndex === rowIndex
          ? null
          : prev.editingRow,
    }));
  };

  handleValueChange = (rowIndex, field, value, tab, isNoQR = false) => {
    this.setState((prev) => {
      const tableKey = isNoQR ? "dataTableNoQR" : "dataTable";
      const targetTable = prev[tableKey] || {};
      const rows = Array.isArray(targetTable[tab]) ? [...targetTable[tab]] : [];

      if (!rows[rowIndex]) return prev;

      rows[rowIndex] = {
        ...rows[rowIndex],
        [field]: value === "" ? null : Number(value),
      };

      return {
        ...prev,
        [tableKey]: {
          ...targetTable,
          [tab]: rows,
        },
      };
    });
  };

  // handleSelectChange = (rowIndex, field, option, tab, isNoQR = false) => {
  //   this.setState((prev) => {
  //     const tableKey = isNoQR ? "dataTableNoQR" : "dataTable";
  //     const targetTable = prev[tableKey] || {};
  //     const rows = Array.isArray(targetTable[tab]) ? [...targetTable[tab]] : [];

  //     if (!rows[rowIndex]) return prev;

  //     const fieldMap = {
  //       KSU: { code: "ksuCode", name: "ksuName", category: "ksuCategory" },
  //       Hadiah: {
  //         code: "giftCode",
  //         name: "giftName",
  //         category: "giftCategory",
  //       },
  //       OtherItem: {
  //         code: "otherItemCode",
  //         name: "otherItemName",
  //         category: "otherItemCategory",
  //       },
  //       Part: { code: "partCode", name: "partName", category: "partCategory" },
  //     };

  //     const map = fieldMap[tab];
  //     if (!map) return prev;

  //     const updatedRow = { ...rows[rowIndex] };

  //     updatedRow[map.code] = option?.value || null;
  //     updatedRow[map.name] = option?.name || null;
  //     updatedRow[map.category] = option?.category || null;

  //     rows[rowIndex] = updatedRow;

  //     return {
  //       ...prev,
  //       [tableKey]: {
  //         ...targetTable,
  //         [tab]: rows,
  //       },
  //     };
  //   });
  // };

  handleSelectChange = (rowIndex, field, option, tab, isNoQR = false) => {
    this.setState((prev) => {
      const tableKey = isNoQR ? "dataTableNoQR" : "dataTable";
      const targetTable = prev[tableKey] || {};
      const rows = Array.isArray(targetTable[tab]) ? [...targetTable[tab]] : [];

      if (!rows[rowIndex]) return prev;

      const fieldMap = {
        KSU: { code: "ksuCode", name: "ksuName", category: "ksuCategory" },
        Hadiah: {
          code: "giftCode",
          name: "giftName",
          category: "giftCategory",
        },
        OtherItem: {
          code: "otherItemCode",
          name: "otherItemName",
          category: "otherItemCategory",
        },
        Part: { code: "partCode", name: "partName", category: "partCategory" },
      };

      const map = fieldMap[tab];
      if (!map) return prev;

      const updatedRow = { ...rows[rowIndex] };

      updatedRow[map.code] = option?.value || null;
      updatedRow[map.name] = option?.name || null;
      updatedRow[map.category] = option?.category || null;

      const STOCK_LIST_MAP = {
        Hadiah: "listHadiah",
        Part: "listPart",
        OtherItem: "listOtherItem",
        KSU: "listKSU",
      };

      const STOCK_CODE_KEY_MAP = {
        Hadiah: "itemCode",
        Part: "itemCode",
        OtherItem: "itemCode",
        KSU: "ksuCode",
      };

      const listKey = STOCK_LIST_MAP[tab];
      const masterList = prev[listKey] || [];
      const masterCodeKey = STOCK_CODE_KEY_MAP[tab];
      const selectedItem = masterList.find(
        (item) => item?.[masterCodeKey] === option?.value,
      );

      console.log(updatedRow);
      console.log(selectedItem);

      updatedRow.inStock =
        selectedItem?.inStock === undefined ? null : selectedItem.inStock;
      rows[rowIndex] = updatedRow;

      updatedRow.qty =
        selectedItem?.qty === undefined ? null : selectedItem.qty;
      rows[rowIndex] = updatedRow;

      return {
        ...prev,
        [tableKey]: {
          ...targetTable,
          [tab]: rows,
        },
      };
    });
  };

  renderAlertBarcodeUsed = () => {
    let { ksuBarcode, giftBarcode, otherBarcode, partBarcode, visible} = this.state.barcodeUsed;
    return (
      <SimpleAlert
        title={"Informasi"}
        visible={visible}
        content={
          <div style={{textAlign:'left'}}>
            <p style={{marginBottom:'10px'}}>Barcode di bawah sudah di pakai.</p>
            {!R.isNil(ksuBarcode) && ksuBarcode.length > 0 && (
              <>
                <p style={{marginBottom:'5px'}}>QR Code KSU: </p>
                <FlexView style={{gap:'10px', maxHeight: "200px", overflowY: "auto", marginBottom:'10px'}}>
                  <ul
                    style={{
                      listStyleType: 'circle',
                      paddingLeft: '20px'
                    }}
                  >
                    {ksuBarcode.map(item=> <li key={item}>{item}</li>)}
                  </ul>
                </FlexView>
              </>)}
            {!R.isNil(giftBarcode) && giftBarcode.length > 0 && (
              <>
                <p style={{marginBottom:'5px'}}>QR Code Hadiah: </p>
                <FlexView style={{gap:'10px', maxHeight: "200px", overflowY: "auto", marginBottom:'10px'}}>
                  <ul
                    style={{
                      listStyleType: 'circle',
                      paddingLeft: '20px'
                    }}
                  >
                    {giftBarcode.map(item=> <li key={item}>{item}</li>)}
                  </ul>
                </FlexView>
              </>)}
            {!R.isNil(otherBarcode) && otherBarcode.length > 0 && (
              <>
                <p style={{marginBottom:'5px'}}>QR Code Barang Lain: </p>
                <FlexView style={{gap:'10px', maxHeight: "200px", overflowY: "auto", marginBottom:'10px'}}>
                  <ul
                    style={{
                      listStyleType: 'circle',
                      paddingLeft: '20px'
                    }}
                  >
                    {otherBarcode.map(item=> <li key={item}>{item}</li>)}
                  </ul>
                </FlexView>
              </>)}
            {!R.isNil(partBarcode) && partBarcode.length > 0 && (
              <>
                <p style={{marginBottom:'5px'}}>QR Code Part: </p>
                <FlexView style={{gap:'10px', maxHeight: "200px", overflowY: "auto", marginBottom:'10px'}}>
                  <ul
                    style={{
                      listStyleType: 'circle',
                      paddingLeft: '20px'
                    }}
                  >
                    {partBarcode.map(item=> <li key={item}>{item}</li>)}
                  </ul>
                </FlexView>
              </>)}
            <p style={{marginTop:'10px'}}>Silakan cek kembali.</p>
          </div>
        }
        onClickClose={() => this.handleAlertBarcodeUsed(false)}
        additionalButtons={(<SimpleButton onClick={() => this.handleAlertBarcodeUsed(false)}>OK</SimpleButton>)}
      />
    )
  };

  render() {
    return (
      <>
        <SimpleModal
          title="EKSPEDISI"
          visible={this.props.visible}
          onClickClose={this.props.onClickClose}
          content={
            <ModalContainer>
              <EkspedisiDetailContentInput
                {...this.props}
                dataHeader={this.state.dataHeader}
              />
              <Tabs>
                <TabList>
                  <Tab>KSU</Tab>
                  <Tab>Hadiah</Tab>
                  <Tab>Barang Lain</Tab>
                  <Tab>Part</Tab>
                  <Tab>Sopir</Tab>
                  <Tab>Foto</Tab>
                </TabList>
                {this.TAB_LIST.map((item, index) => {
                  return (
                    <TabPanel id={`tab-${index}`} key={item}>
                      <EkspedisiDetailTab
                        {...this.props}
                        id={`tab-${index}-${item}`}
                        tab={CONFIG_DETAIL.TAB[item]}
                        tabParent={this.props.tab}
                        actionType={this.props.actionType}
                        dataTable={this.state.dataTable[item]}
                        dataTableNoQR={this.state.dataTableNoQR[item]}
                        editingRow={this.state.editingRow}
                        isAddingRow={this.state.isAddingRow}
                        handleValueChange={this.handleValueChange}
                        onChangeActionQRCode={this.handleActionQRCode}
                        onChangeActionNoQRCode={this.handleActionNoQRCode}
                        onChangeActionMenyusul={this.handleActionMenyusul}
                        onChangeActionNoQRMenyusul={
                          this.handleActionNoQRMenyusul
                        }
                        onAddRowWithQR={this.handleAddRowWithQR}
                        onAddRowWithoutQR={this.handleAddRowWithoutQR}
                        onEditRow={this.handleEditRow}
                        onSaveRow={this.handleSaveRow}
                        onDeleteRow={this.handleDeleteRow}
                        onEditRowNoQR={this.handleEditRowNoQR}
                        onSaveRowNoQR={this.handleSaveRowNoQR}
                        onDeleteRowNoQR={this.handleDeleteRowNoQR}
                        handleTriggerLoading={this.handleTriggerLoading}
                        handleSelectChange={this.handleSelectChange}
                        lists={{
                          listKSU: this.state.listKSU,
                          listHadiah: this.state.listHadiah,
                          listOtherItem: this.state.listOtherItem,
                          listPart: this.state.listPart,
                        }}
                      />
                    </TabPanel>
                  );
                })}
                <TabPanel id={`tab-4-Sopir`}>
                  <>
                    <SimpleDDL
                      id="select_options_nama_sopir"
                      box="search"
                      name="deliveryManId"
                      label="Nama Supir"
                      mandatory
                      isClearable
                      errorMessage={
                        this.state.showErrors &&
                        !this.state.dataSupir?.deliveryManId
                          ? "Field belum diisi"
                          : ""
                      }
                      containerclassname="width width-250px"
                      menuPosition="fixed"
                      options={this.state.supirOptions}
                      readOnly={
                        this.props.selectedData.statusEkspedisi !== "DRAFT"
                      }
                      value={this.state.dataSupir?.driverName}
                      onChange={(value) =>
                        this.setState((prevState) => ({
                          ...prevState,
                          dataSupir: {
                            ...prevState.dataSupir,
                            driverName: value,
                          },
                        }))
                      }
                    />
                    <SimpleTextArea
                      id="text_catatan_alamat"
                      name="addressNote"
                      label="Catatan Alamat"
                      typeInputCase="normal"
                      value={this.state.dataSupir?.addressNote}
                      readOnly={
                        this.props.selectedData.statusEkspedisi !== "DRAFT"
                      }
                      onChange={({ target }) =>
                        this.setState((prevState) => ({
                          ...prevState,
                          dataSupir: {
                            ...prevState.dataSupir,
                            addressNote: target.value,
                          },
                        }))
                      }
                    />
                  </>
                </TabPanel>
                <TabPanel id={`tab-5-Foto`}>
                  <div className="grid grid-3x gap-20px grid-mobile-none">
                    <div id="grid-1">
                      <SimpleUploadImage
                        id="input_upload_foto_gesekan"
                        name="photo"
                        label="Foto Gesekan"
                        category=""
                        value={this.state.dataFoto}
                      />
                    </div>
                    <div id="grid-2"></div>
                    <div id="grid-3"></div>
                  </div>
                </TabPanel>
              </Tabs>

              <div style={{ textAlign: "right", marginTop: "20px" }}>
                <FlexView hAlignContent={"right"}>
                  {this.props.selectedData.statusEkspedisi === "DRAFT" ||
                  this.props.isMenyusul ? (
                    <>
                      <SimpleButton
                        type="button"
                        text="Refresh"
                        onClick={this.handleRefresh}
                      />
                      <SimpleButton
                        type="button"
                        text="Proses"
                        onClick={this.handleProses}
                      />
                      <SimpleButton
                        type="button"
                        text="Cetak"
                        onClick={this.handleCetakVisibility}
                      />
                    </>
                  ) : (
                    <>
                      <SimpleButton
                        type="button"
                        text="Keluar"
                        onClick={this.props.onClickClose}
                      />
                      <SimpleButton
                        type="button"
                        text="Cetak"
                        secondary={this.props.selectedData.statusEkspedisi === "TOLAK" || this.props.selectedData.statusEkspedisi === "CANCEL"}
                        disabled={this.props.selectedData.statusEkspedisi === "TOLAK" || this.props.selectedData.statusEkspedisi === "CANCEL"}
                        onClick={this.handleCetakVisibility}
                      />
                    </>
                  )}
                </FlexView>
              </div>
            </ModalContainer>
          }
        />

        {this.state.cetakVisible && (
          <SimpleModal
            title="Cetakan"
            styles={{ width: "40%" }}
            content={
              <ModalContainer>
                <SimpleDDL
                  id="select_options_cetakan"
                  box="search"
                  name="cetakan"
                  label="Jenis Cetakan"
                  menuPosition="fixed"
                  options={[
                    { label: "Cetakan BAST Dealer", value: "BAST_DEALER" },
                    {
                      label: "Cetakan BAST Main Dealer",
                      value: "BAST_MAIN_DEALER",
                    },
                    {
                      label: "Cetakan Label Buku Service",
                      value: "BUKU_SERVICE",
                    },
                    { label: "Cetakan BSTK Hadiah", value: "BSTK_HADIAH" },
                  ]}
                  onChange={(value) =>
                    this.setState((prevState) => ({
                      ...prevState,
                      bstkHadiahVisible: R.equals(value?.value, "BSTK_HADIAH"),
                      dataCetakan: value,
                    }))
                  }
                />

                <div style={{ textAlign: "right", marginTop: "20px" }}>
                  <FlexView hAlignContent={"right"}>
                    <SimpleButton
                      type="button"
                      text="Cetak"
                      onClick={this.handleCetak}
                    />
                  </FlexView>
                </div>
              </ModalContainer>
            }
            visible={this.state.cetakVisible}
            onClickClose={this.handleCetakVisibility}
          />
        )}

        {this.state.bstkHadiahVisible && (
          <SimpleModal
            title="Cetakan"
            styles={{ width: "40%" }}
            visible={this.state.bstkHadiahVisible}
            onClickClose={() =>
              this.setState((prevState) => ({
                ...prevState,
                bstkHadiahVisible: !prevState.bstkHadiahVisible,
              }))
            }
            content={
              <ModalContainer>
                <SimpleInput
                  id="input_text_row_1"
                  name="row1"
                  label="Baris 1"
                  value={this.state.dataCetakanBSTKHadiah?.row1}
                  onChange={(e) =>
                    this.handleChangeCetakBSTKHadiah("row1", e.target.value)
                  }
                />
                <SimpleInput
                  id="input_text_row_2"
                  name="row2"
                  label="Baris 2"
                  value={this.state.dataCetakanBSTKHadiah?.row2}
                  onChange={(e) =>
                    this.handleChangeCetakBSTKHadiah("row2", e.target.value)
                  }
                />
                <SimpleInput
                  id="input_text_row_3"
                  name="row3"
                  label="Baris 3"
                  value={this.state.dataCetakanBSTKHadiah?.row3}
                  onChange={(e) =>
                    this.handleChangeCetakBSTKHadiah("row3", e.target.value)
                  }
                />
                <SimpleTextArea
                  id="input_text_row_4"
                  name="row4"
                  label="Baris 4"
                  value={this.state.dataCetakanBSTKHadiah?.row4}
                  onChange={(e) =>
                    this.handleChangeCetakBSTKHadiah("row4", e.target.value)
                  }
                />

                <div style={{ textAlign: "right", marginTop: "20px" }}>
                  <FlexView hAlignContent={"center"}>
                    <SimpleButton
                      type="button"
                      text="Cetak"
                      onClick={this.handleCetak}
                      disabled={!this.props.userAccess?.updateAccess}
                    />
                  </FlexView>
                </div>
              </ModalContainer>
            }
          />
        )}

        {this.state.warningVisible && (
          <SimpleAlert
            title="Peringatan!"
            visible={this.state.warningVisible}
            content={
              <div>
                <p>{this.state.warningMessage}</p>
                <FlexView hAlignContent="center">
                  <SimpleButton
                    className="margin-top-15px"
                    text="OK"
                    onClick={this.handleAlertWarningVisibility}
                  />
                </FlexView>
              </div>
            }
            onClickClose={this.handleAlertWarningVisibility}
          />
        )}

        {this.state.alertModalProsesVisible && (
          <SimpleAlert
            title={"Peringatan!"}
            content={"Terdapat data yang belum lengkap, mohon periksa kembali"}
            visible={this.state.alertModalProsesVisible}
            onClickClose={this.handleAlertModalProsesVisibility}
            additionalButtons={
              <FlexView>
                <SimpleButton
                  type="button"
                  text="OK"
                  onClick={() => this.handleAlertModalProsesVisibility()}
                />
              </FlexView>
            }
          />
        )}

        {this.state.previewCetakVisible && (
          <EkspedisiPreviewPDF
            PDF={this.state.PDF}
            visible={this.state.previewCetakVisible}
            onPreviewQr={() => this.previewCetakanVisibility("close")}
            onStateChange={this.handleStateChange}
          />
        )}
        {this.renderAlertBarcodeUsed()}
        <SimpleLoadingOverlay active={this.state.loading} />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    h1Module: state.h1Module,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EkspedisiDetailContent);
